import { VersionState } from "./versionState";
import { Action, Actions } from "./versionActions";

export default (state: typeof VersionState, action: Action): typeof VersionState => {
  switch (action.type) {
    case Actions.DISMISS:
      return {
        ...state,
        hasNewVersion: false,
      };
    case Actions.SET_FIRST_TIME_LOADING:
      return {
        ...state,
        firstTimeLoading: action.payload,
      };
    case Actions.SET_VERSION:
      return {
        ...state,
        currentVersion: action.payload.version,
      };

    case Actions.SET_INITIAL_VERSION:
      return {
        ...state,
        currentVersion: action.payload.version,
        initialVersion: action.payload.version,
      };
    case Actions.SET_HAS_NEW_VERSION:
      return {
        ...state,
        hasNewVersion: action.payload,
      };
    default:
      return state;
  }
};
